'use strict';

angular.module('shop').controller('DeliveryInformationController', function ($rootScope, $scope, $state, CustomerService, ShopService) {

	$scope.loading = true;
	$scope.customerform = {};
	$scope.pickup = false;

	CustomerService.get().then(function (customer) {
		$scope.customer = customer;
        
		$scope.customerform.firstName = customer.firstName;
		$scope.customerform.lastName = customer.lastName;
		$scope.customerform.mobile = customer.mobile;
		$scope.customerform.shippingAddress = angular.copy(customer.shippingAddress);

		$scope.cart = ShopService.getCart();
		
		$scope.customerform.shippingAddress.zipCode = $scope.cart.zipcode;
		$scope.customerform.shippingAddress.city = $scope.cart.city;

		// Update new customerID on cart
		$scope.cart.customerID = $scope.customer.id;
		ShopService.setCart($scope.cart);

		ShopService.getSummary($scope.cart).then(function(summary) {

			// If total price of order is 0 we skip Klarna checkout
			var totalPrice = summary.payMethodPrice + summary.missingPrice;
			if (totalPrice == 0) {
				$scope.payedOrder = true;
			}

			if (!summary.summaryArticles || summary.summaryArticles.length === 0) {
				$state.go('checkout');
				return;
			}

			$scope.loading = false;
		});
	});

	$scope.process = function (form) {
		if (!form || form.$invalid) {
			window.scrollTo(0, 0);
			return;
		}

		$scope.loading = true;

		CustomerService.saveDeliveryInformation($scope.customerform).then(function () {
			$scope.loading = false;
			$state.go('payment');
		});
	};
});